module.exports = __webpack_public_path__ + "img/icon-frontage.11032729.svg";